<template>
  <div class="home_bg">
    <svg v-if="token" xmlns="http://www.w3.org/2000/svg" :id="id" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" :width="svgwidth"
         :height="svgheigth" style="cursor: default;max-height: 900px;margin-top: 50px;">
      <defs>
        <g id='img_l'>
          <image xlink:href="/static/images/A-L.png" width='130' height='50'>
          </image>
        </g>
        <g id='img_l_b'>
          <image xlink:href="/static/images/A-L_b.png" width='130' height='50'>
          </image>
        </g>
        <g id='img_r'>
          <image xlink:href="/static/images/A-R.png" width='130' height='50'>
          </image>
        </g>
        <g id='img_r_b'>
          <image xlink:href="/static/images/A-R_b.png" width='130' height='50'>
          </image>
        </g>
        <g id='img_r2'>
          <image xlink:href="/static/images/B.png" width='160' height='50'>
          </image>
        </g>
        <g id='img_r2_b'>
          <image xlink:href="/static/images/B_b.png" width='160' height='50'>
          </image>
        </g>
        <g id='img_fk'>
          <image xlink:href="/static/images/fk.png" width='130' height='50'>
          </image>
        </g>
        <g id='img_fk_b'>
          <image xlink:href="/static/images/fk_b.png" width='130' height='50'>
          </image>
        </g>
        <filter id="dilate">
          <feMorphology operator="dilate" radius=".2" />
        </filter>
        <filter id="blurFilter2" y="-10" height="40" x="-10" width="150">
          <feOffset in="SourceAlpha" dx="3" dy="3" result="offset2" />
          <feGaussianBlur in="offset2" stdDeviation="3" result="blur2" />

          <feMerge>
            <feMergeNode in="blur2" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <g :id="'g'+Index" v-for="(item,Index) in menulist" :key="Index" :transform="'translate('+getxy(item.svg)+')'"
         v-if='item.svg' style="cursor: pointer;">
        <g v-if='item.svg.d'>
          <template v-if='isArray(item.svg.d)'>
            <polyline v-for="(d,i) in item.svg.d" :key="i" fill="none" stroke="#008aff" stroke-width="2" :points="d"
                      transform="translate( 0 0 )">
            </polyline>
          </template>
          <template v-else>
            <polyline fill="none" stroke="#008aff" stroke-width="2" :points="item.svg.d" transform="translate( 0 0 )">
            </polyline>
          </template>
        </g>
        <rect fill="none" stroke="#008aff" v-if='item.svg.state==1' stroke-width="1.5" :width="(item.name.length*25)"
              height="50" :id="'svg'+Index" rx="10" ry="10" />
        <use :id="'g'+Index+'_use'" :idval="'g'+Index+'_use'" :xlink:href="'#'+item.svg.imgurl" v-if='item.svg.state==2'
             @mouseover="over" @mouseout='out($event)' @click="menuclick(item)"></use>
        <text :id="'text'+Index" :idval="'g'+Index+'_use'" text-rendering="inherit" dominant-baseline="text-before-edge"
              font-size="16" :x="fontx(item)" :y="fonty(item)" fill="#fff" :style='item.svg.style' @mouseover="over"
              @mouseout='out($event)' :filter='item.svg.filter' @click="menuclick(item)">
          {{item.petname?item.petname: item.name}}</text>
      </g>

      <g :id='"g_img"+Index' v-for='(item,Index) in imagelist' :key="'img'+Index"
         :transform="'translate('+getxy(item)+')'">
        <image :xlink:href="item.imgurl"></image>
      </g>
    </svg>


    <svg v-if="!token" xmlns="http://www.w3.org/2000/svg" :id="id" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" :width="svgwidth"
         :height="svgheigth" style="cursor: default;">
      <defs>
        <g id='img_l'>
          <image xlink:href="/static/images/A-L.png" width='130' height='50'>
          </image>
        </g>
        <g id='img_l_b'>
          <image xlink:href="/static/images/A-L_b.png" width='130' height='50'>
          </image>
        </g>
        <g id='img_r'>
          <image xlink:href="/static/images/A-R.png" width='130' height='50'>
          </image>
        </g>
        <g id='img_r_b'>
          <image xlink:href="/static/images/A-R_b.png" width='130' height='50'>
          </image>
        </g>
        <g id='img_r2'>
          <image xlink:href="/static/images/B.png" width='160' height='50'>
          </image>
        </g>
        <g id='img_r2_b'>
          <image xlink:href="/static/images/B_b.png" width='160' height='50'>
          </image>
        </g>
        <g id='img_fk'>
          <image xlink:href="/static/images/fk.png" width='130' height='50'>
          </image>
        </g>
        <g id='img_fk_b'>
          <image xlink:href="/static/images/fk_b.png" width='130' height='50'>
          </image>
        </g>
        <filter id="dilate">
          <feMorphology operator="dilate" radius=".2" />
        </filter>
        <filter id="blurFilter2" y="-10" height="40" x="-10" width="150">
          <feOffset in="SourceAlpha" dx="3" dy="3" result="offset2" />
          <feGaussianBlur in="offset2" stdDeviation="3" result="blur2" />

          <feMerge>
            <feMergeNode in="blur2" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <g :id="'g'+Index" v-for="(item,Index) in nomenulist" :key="Index" :transform="'translate('+getxy(item.svg)+')'"
         v-if='item.svg' style="cursor: pointer;">
        <g v-if='item.svg.d'>
          <template v-if='isArray(item.svg.d)'>
            <polyline v-for="(d,i) in item.svg.d" :key="i" fill="none" stroke="#008aff" stroke-width="2" :points="d"
                      transform="translate( 0 0 )">
            </polyline>
          </template>
          <template v-else>
            <polyline fill="none" stroke="#008aff" stroke-width="2" :points="item.svg.d" transform="translate( 0 0 )">
            </polyline>
          </template>
        </g>
        <rect fill="none" stroke="#008aff" v-if='item.svg.state==1' stroke-width="1.5" :width="(item.name.length*25)"
              height="50" :id="'svg'+Index" rx="10" ry="10" />
        <use :id="'g'+Index+'_use'" :idval="'g'+Index+'_use'" :xlink:href="'#'+item.svg.imgurl" v-if='item.svg.state==2'
             @mouseover="over" @mouseout='out($event)' @click="menuclick(item)"></use>
        <text :id="'text'+Index" :idval="'g'+Index+'_use'" text-rendering="inherit" dominant-baseline="text-before-edge"
              font-size="16" :x="fontx(item)" :y="fonty(item)" fill="#fff" :style='item.svg.style' @mouseover="over"
              @mouseout='out($event)' :filter='item.svg.filter' @click="menuclick(item)">
          {{item.petname?item.petname: item.name}}</text>
      </g>

      <g :id='"g_img"+Index' v-for='(item,Index) in imagelist' :key="'img'+Index"
         :transform="'translate('+getxy(item)+')'">
        <image :xlink:href="item.imgurl"></image>
      </g>
    </svg>

    <!-- 投资日历2025年未更新，暂时隐藏 -->
    <!-- <div style="display: none" @click="openCalendar" class="yearImg"><img src="../assets/images/首页入口2025.gif" alt="loading"></div> -->
    <!-- <div v-if="token" style="display: none" v-trigger @click="openCalendar"></div> -->
    <!-- <calendar v-if="calendaRVisiAble" ref="dialog"></calendar> -->
  </div>
</template>

<script>
import Calendar from "../components/common/Calendar";
const font1 = 'font-size:14;fill:#fff;display:none;';
export default {
  name: 'index_com',
  components: {
    Calendar
  },
  directives: {
    trigger: {
      inserted(el, binging) {
        // 投资日历已隐藏，不再自动触发
        const firstDate = localStorage.getItem('firstDate1');
        // 获取当前时间（年月日）
        const now = new Date().toLocaleDateString();
        // 转换成时间戳
        const time = Date.parse(new Date(now));
        if (!firstDate) {
          console.log('time1', '今天第一次开启1')
          localStorage.setItem('firstDate1', JSON.stringify(time))
          // el.click()  // 投资日历已隐藏
        } else {
          if (time > firstDate) {
            console.log('time2', '今天第一次开启2')
            localStorage.setItem('firstDate1', JSON.stringify(time))
          }
        }
      }
    }
  },
  props: {
    query: null
  },
  data() {
    return {
      calendaRVisiAble:false,
      svgbasewidth: 1200,
      svgbaseheight: 900,
      svgwidth: 1200,
      svgheigth: 900,
      id:'svg',
      token:window.localStorage.getItem('token'),
      menudata: [
        {
        name: '首页',
        petname: '股票市场',
        path: '/',
        current: true,
        svg: {
          local: 'l,b',
          x: '520',
          y: '30',
          d: [
            '70,-10 70,-585 65,-590 -45,-590',
            '68,-10 68,-200 63,-205 -70,-205',
            '72,-10 72,-485 77,-490 200,-490',
            '72,-10 72,-140 77,-145 230,-145'
          ],
          style: 'font-size:20;fill:#AFDAFF;font-weight: 600;cursor: default;',
        }
      }, {
        name: '大势',
        path: 'trend',
        headstyle: 1,
        describe: '把脉全球政经，预判大势拐点，寻找资产配置的核心密码',
        svg: {
          local: 't,l',
          x: '320',
          y: '125',
          d: [
            '0,25 0,25',
            '130,25 150,25 155,30 155,185'
          ],
          state: 2,
          imgurl: 'img_fk',
          style: 'font-size:20;'
        },
          children: [{
            name: '中国首席财经',
            path: 'trend',
            currentTab:'second',
            activeName:'second',
            updatetime: '(更新频率：每周一、三、五)',
            svg: {
              local: 't,l',
              x: '210',
              y: '110',
              state: 0,
              style: font1,
            }
          }, {
            name: '首席证券内参',
            path: 'trend',
            currentTab:'third',
            activeName:'third',
            updatetime: '(更新频率：交易日)',
            svg: {
              local: 't,l',
              x: '210',
              y: '140',
              state: 0,
              style: font1,
            }
          },
          ]
      }, {
        name: '复盘',
        path: 'review',
        headstyle: 4,
        describe: '揭秘异动热点，捕捉投资机会，决策快人一步',
        svg: {
          local: 't,l',
          x: '320',
          y: '360',
          d: '130,25 150,25 155,20 155,-50',
          state: 2,
          imgurl: 'img_fk',
          style: 'font-size:20;'
        },
        children: [{
          name: '收盘观潮',
          currentTab:'first',
          activeName:'first',
          url: 'market/modelList/list',
          path: 'review',
          updatetime: '（更新频率：每周日）',
          svg: {
            local: 't,l',
            x: '210',
            y: '330',
            state: 0,
            style: font1,
          }
        }, {
          name: '数据解盘',
          currentTab:'second',
          activeName:'second',
          url: 'market/modelList/list',
          models_name: '大势小结（文字）,大势小结（表格）,一周总结,每周涨停复盘,每周题材复盘,每周数据复盘',
          path: 'review',
          updatetime: '（更新频率：每周日）',
          svg: {
            local: 't,l',
            x: '210',
            y: '360',
            state: 0,
            style: font1,
          }
        }, {
          name: '每周复盘',
          currentTab:'third',
          activeName:'third',
          url: 'market/modelList/list',
          models_name: '大势小结（文字）,大势小结（表格）,一周总结,每周涨停复盘,每周题材复盘,每周数据复盘',
          path: 'review',
          updatetime: '（更新频率：每周日）',
          svg: {
            local: 't,l',
            x: '210',
            y: '390',
            state: 0,
            style: font1,
          }
        }]
      }, {
        name: '市场',
        path: 'market',
        headstyle: 4,
        describe: '揭秘异动热点，捕捉投资机会，决策快人一步',
        svg: {
          local: 't,r',
          x: '320',
          y: '125',
          d: [
            '130,25 130,25',
            '0,25 -25,25 -30,30 -30,260'
          ],
          state: 2,
          imgurl: 'img_fk',
          style: 'font-size:20;'
        },
          children: [{
            name: '精选头条',
            path: 'market',
            currentTab:'second',
            activeName:'second',
            svg: {
              local: 't,r',
              x: '190',
              y: '70',
              state: 0,
              style: font1,
            }
          }, {
            name: '市场热点',
            currentTab:'third',
            activeName:'third',
            path: 'market',
            svg: {
              local: 't,r',
              x: '190',
              y: '110',
              state: 0,
              style: font1,
            }
          }, {
            name: '盘中直击',
            currentTab:'fourth',
            activeName:'fourth',
            path: 'market',
            svg: {
              local: 't,r',
              x: '190',
              y: '150',
              state: 0,
              style: font1,
            }
          }, {
            name: '要闻点评',
            currentTab:'five',
            activeName:'five',
            path: 'market',
            svg: {
              local: 't,r',
              x: '190',
              y: '190',
              state: 0,
              style: font1,
            }
          }
          ]
      }, {
        name: '机会',
        path: 'chance',
        headstyle: 2,
        icon: 'icon5',
        svg: {
          local: 't,r',
          x: '320',
          y: '360',
          d: [
            '130,25 155,25',
            '0,25 -30,25'
          ],
          state: 2,
          imgurl: 'img_fk',
          style: 'font-size:20;'
        },
        describe: '机会掘金:独家原创日历，捕捉投资机会。精选卖方研究，深挖最有价值的题材方向',
        children: [{
          name: '盘前必读',
          currentTab:'first',
          activeName:'first',
          path: 'chance',
          icon: 'icon5',
          updatetime: '(交易日更新)',
          svg: {
            local: 't,r',
            x: '130',
            y: '290',
            d: '0,25 -30,25 -35,30 -35,160',
            state: 2,
            imgurl: 'img_r'
          },
          children: [{
            name: '早安谍报',
            currentTab:'second',
            activeName:'second',
            path: 'chance',
            svg: {
              local: 't,r',
              x: '10',
              y: '260',
              state: 0,
              style: font1,
            }
          }, {
            name: '盘前点金',
            currentTab:'third',
            activeName:'third',
            path: 'chance',
            svg: {
              local: 't,r',
              x: '10',
              y: '285',
              state: 0,
              style: font1,
            }
          }, {
            name: '题材挖掘',
            currentTab:'fourth',
            activeName:'fourth',
            path: 'chance',
            svg: {
              local: 't,r',
              x: '10',
              y: '310',
              state: 0,
              style: font1,
            }
          }]
        }, {
          name: '投资日历',
          currentTab:'five',
          activeName:'five',
          path: 'chance',
          icon: 'icon5',
          updatetime: '(交易日更新)',
          svg: {
            local: 't,r',
            x: '130',
            y: '370',
            state: 2,
            imgurl: 'img_r'
          },
          describe: '国内首创将机会挖掘与风险提示做成深度前瞻的研究型产品。主打深度研究与独家原创，在重大政策和事件的前瞻性上下苦功，旨在为投资者捕捉投资机会，预判风险事件并作出提示。'
        }, {
          name: '脱水研报',
          currentTab:'six',
          activeName:'six',
          path: 'chance',
          icon: 'icon5',
          updatetime: '(交易日收盘后更新)',
          svg: {
            local: 't,r',
            x: '130',
            y: '450',
            d: '0,25 -30,25 -35,20 -35,0',
            state: 2,
            imgurl: 'img_r'
          },
          describe: '大数据结合专业实力，在海量卖方研究中深度挖掘最有价值的策略、题材和个股，并以最精炼的语言精准反馈研报的核心逻辑，尽可能呈现更多超预期的信息增量。'
        }]
      },
      //   {
      //   name: '风险',
      //   path: 'risk',
      //   describe: '全方位监测风险事件，深挖驱动逻辑，寻找避险最优解',
      //   svg: {
      //     local: 't,r',
      //     x: '320',
      //     y: '500',
      //     d: [
      //       '0,25 -25,25 -30,20 -30,-100'
      //     ],
      //     state: 2,
      //     imgurl: 'img_fk',
      //     style: 'font-size:20;'
      //   }
      // },
        {
        name: '个股',
        path: 'stocks',
        describe: '人工智能技术结合专业实力，多维度解析个股核心价值',
        headstyle: 4,
        svg: {
          local: 't,l',
          x: '320',
          y: '600',
          d: '0,25 -35,25',
          state: 2,
          imgurl: 'img_fk',
          style: 'font-size:20;'
        },
        children: [{
          name: '新股',
          currentTab:'second',
          activeName:'second',
          path: 'stocks',
          icon: 'icon11',
          headstyle: -1,
          describe: '一站式打新指南，IPO风向尽在掌握。',
          svg: {
            local: 't,l',
            x: '130',
            y: '500',
            d: '130,25 150,25 155,30 155,200',
            state: 2,
            imgurl: 'img_l'
          },
          children: [{
            name: '申购日',
            currentTab:'second',
            activeName:'second',
            path: 'stocks',
            svg: {
              local: 't,l',
              x: '20',
              y: '480',
              state: 0,
              style: font1,
            }
          }, {
            name: '上市日',
            currentTab:'third',
            activeName:'third',
            path: 'stocks',
            svg: {
              local: 't,l',
              x: '20',
              y: '520',
              state: 0,
              style: font1,
            }
          }]
        },
          {
            name: '热股',
            path: 'stocks',
            currentRgTab:'fourth',
            activeRgName:'fourth',
            icon: 'icon13',
            headstyle: 2,
            describe: '复盘强势题材与个股，甄选具备短线爆发潜力的优质标的。',
            svg: {
              local: 't,l',
              x: '130',
              y: '580',
              state: 2,
              imgurl: 'img_l'
            },
            children: [{
              name: '涨停分析',
              currentRgTab:'five',
              activeRgName:'five',
              models_name: '涨停预测',
              path: 'stocks',
              icon: 'icon13',
              updatetime: '（交易日收盘后更新）',
              svg: {
                local: 't,l',
                x: '20',
                y: '550',
                state: 0,
                style: font1,
              },
              describe: '通过对短期市场交易信号与公开市场信息的跟踪，筛选具备短线爆发潜力的优质标的，核心投研团队已积累多年跟踪与反馈经验，具备一套筛选短线强势股的成熟体系。'
            }, {
              name: '涨停预测',
              path: 'stocks',
              currentRgTab:'six',
              activeRgName:'six',
              models_name: '涨停分析1',
              icon: 'icon13',
              updatetime: '（交易日更新）',
              svg: {
                local: 't,l',
                x: '20',
                y: '580',
                state: 0,
                style: font1,
              },
              describe: '通过对当天市场强势板块进行复盘整理，梳理出当天全部强势题材与个股，以图表形式直观反映题材强弱排序，以及各题材的人气龙头股。'
            }, {
              name: '强势股解析',
              path: 'stocks',
              currentRgTab:'seven',
              activeRgName:'seven',
              models_name: '涨停分析1',
              icon: 'icon13',
              updatetime: '（交易日更新）',
              svg: {
                local: 't,l',
                x: '15',
                y: '610',
                state: 0,
                style: font1,
              },
              describe: '通过对当天市场强势板块进行复盘整理，梳理出当天全部强势题材与个股，以图表形式直观反映题材强弱排序，以及各题材的人气龙头股。'
            }]
          },

          {
            name: '智选',
            currentTab:'one',
            activeName:'one',
            path: 'stocks',
            icon: 'icon12',
            describe: '从价值、市场、技术、资金、研究等五大维度对个股进行综合评估，结合相似K线，得出个股诊断报告。',
            svg: {
              local: 't,l',
              x: '130',
              y: '740',
              d: '130,25 150,25 155,20 155,-50',
              state: 2,
              imgurl: 'img_l'
            },
            children: [{
              name: 'AI诊股',
              path: 'http://develop2.bolanjr.com/',
              islogin: true,
              svg: {
                local: 't,l',
                x: '30',
                y: '760',
                state: 0,
                style: font1,
              }
            }]
          }
        ]
      },
        {
          name: '投顾',
          path: 'invest',
          headstyle: 2,
          icon: 'icon5',
          svg: {
            local: 't,r',
            x: '320',
            y: '660',
            d: [
              '130,25 155,25'
            ],
            state: 2,
            imgurl: 'img_fk',
            style: 'font-size:20;'
          },
          describe: '机会掘金:独家原创日历，捕捉投资机会。精选卖方研究，深挖最有价值的题材方向',
          children: [{
            name: '短线',
            currentTab:'first',
            activeName:'first',
            path: 'invest',
            icon: 'icon5',
            updatetime: '(交易日更新)',
            svg: {
              local: 't,r',
              x: '130',
              y: '560',
              d: '0,25 -30,25 -35,30 -35,200',
              state: 2,
              imgurl: 'img_r'
            },
            children: [{
              name: '天机策',
              currentTab:'first',
              activeName:'first',
              path: 'invest',
              svg: {
                local: 't,r',
                x: '10',
                y: '560',
                state: 0,
                style: font1,
              }
            }]
          }, {
            name: '中线',
            currentTab:'second',
            activeName:'second',
            path: 'invest',
            icon: 'icon5',
            updatetime: '(交易日更新)',
            svg: {
              local: 't,r',
              x: '130',
              y: '760',
              d: '0,25 -30,25 -35,20 -35,0',
              state: 2,
              imgurl: 'img_r'
            },
            describe: '国内首创将机会挖掘与风险提示做成深度前瞻的研究型产品。主打深度研究与独家原创，在重大政策和事件的前瞻性上下苦功，旨在为投资者捕捉投资机会，预判风险事件并作出提示。',
            children: [{
              name: '每月专题精研',
              currentTab:'fourth',
              activeName:'fourth',
              path: 'invest',
              svg: {
                local: 't,r',
                x: '-20',
                y: '740',
                state: 0,
                style: font1,
              }
            }, {
              name: '研选专题金股',
              currentTab:'five',
              activeName:'five',
              path: 'invest',
              svg: {
                local: 't,r',
                x: '-20',
                y: '780',
                state: 0,
                style: font1,
              }
            }]
          },
            // {
            //   name: '长线',
            //   currentTab:'third',
            //   activeName:'third',
            //   path: 'invest',
            //   icon: 'icon5',
            //   updatetime: '(交易日收盘后更新)',
            //   svg: {
            //     local: 't,r',
            //     x: '130',
            //     y: '760',
            //     d: '0,25 -30,25 -35,20 -35,0',
            //     state: 2,
            //     imgurl: 'img_r'
            //   },
            //   describe: '大数据结合专业实力，在海量卖方研究中深度挖掘最有价值的策略、题材和个股，并以最精炼的语言精准反馈研报的核心逻辑，尽可能呈现更多超预期的信息增量。',
            //   children: [{
            //     name: 'VIP投资股池',
            //     currentTab:'third',
            //     activeName:'third',
            //     path: 'invest',
            //     svg: {
            //       local: 't,r',
            //       x: '-25',
            //       y: '760',
            //       state: 0,
            //       style: font1,
            //     }
            //   }]
            // }
          ]
        }, {
          name: '特色',
          path: 'feature',
          headstyle: 2,
          icon: 'icon5',
          children: [{
            name: '理财',
            path: 'feature',
            icon: 'icon5',
            updatetime: '(交易日更新)'
          }, {
            name: '基金',
            path: 'feature',
            icon: 'icon5',
            updatetime: '(交易日更新)',
            describe: '国内首创将机会挖掘与风险提示做成深度前瞻的研究型产品。主打深度研究与独家原创，在重大政策和事件的前瞻性上下苦功，旨在为投资者捕捉投资机会，预判风险事件并作出提示。',
            children: [{
              name: '最新',
              path: 'feature',
            }, {
              name: '配置',
              path: 'feature',
            }, {
              name: '行情',
              path: 'feature',
            }, {
              name: '选基',
              path: 'feature',
            }]
          },
            {
              name: 'ETF投资参考',
              path: 'feature',
              icon: 'icon5',
              updatetime: '(交易日收盘后更新)',
              describe: '大数据结合专业实力，在海量卖方研究中深度挖掘最有价值的策略、题材和个股，并以最精炼的语言精准反馈研报的核心逻辑，尽可能呈现更多超预期的信息增量。'
            },
            {
              name: '可转债投资指南',
              path: 'feature',
              icon: 'icon5',
              updatetime: '(交易日收盘后更新)',
              describe: '大数据结合专业实力，在海量卖方研究中深度挖掘最有价值的策略、题材和个股，并以最精炼的语言精准反馈研报的核心逻辑，尽可能呈现更多超预期的信息增量。'
            },
            {
              name: '港股',
              path: 'feature',
              icon: 'icon5',
              updatetime: '(交易日收盘后更新)',
              describe: '大数据结合专业实力，在海量卖方研究中深度挖掘最有价值的策略、题材和个股，并以最精炼的语言精准反馈研报的核心逻辑，尽可能呈现更多超预期的信息增量。'
            }
          ]
        }, {
          name: '投研库',
          path: 'investmentresearchlibrary',
          headstyle: 2,
          icon: 'icon5',
        }
      ],
      nomenudata: [
        {
          name: '首页',
          petname: '股票市场',
          path: '/',
          current: true,
          svg: {
            local: 'l,b',
            x: '520',
            y: '30',
            d: [
              '70,-10 70,-585 65,-590 -45,-590',
              '68,-10 68,-200 63,-205 -70,-205',
              '72,-10 72,-485 77,-490 200,-490',
              '72,-10 72,-140 77,-145 230,-145'
            ],
            style: 'font-size:20;fill:#AFDAFF;font-weight: 600;cursor: default;',
          }
        }, {
          name: '大势',
          path: 'trend',
          headstyle: 1,
          describe: '把脉全球政经，预判大势拐点，寻找资产配置的核心密码',
          svg: {
            local: 't,l',
            x: '320',
            y: '125',
            d: [
              '0,0 0,0',
              '130,25 150,25 155,30 155,185'
            ],
            state: 2,
            imgurl: 'img_fk',
            style: 'font-size:20;'
          },
        }, {
          name: '复盘',
          path: 'review',
          headstyle: 4,
          describe: '揭秘异动热点，捕捉投资机会，决策快人一步',
          svg: {
            local: 't,l',
            x: '320',
            y: '360',
            d: '130,25 150,25 155,20 155,-50',
            state: 2,
            imgurl: 'img_fk',
            style: 'font-size:20;'
          },
        }, {
          name: '市场',
          path: 'market',
          headstyle: 4,
          describe: '揭秘异动热点，捕捉投资机会，决策快人一步',
          svg: {
            local: 't,r',
            x: '320',
            y: '125',
            d: [
              '0,0 0,0',
              '0,25 -25,25 -30,30 -30,280'
            ],
            state: 2,
            imgurl: 'img_fk',
            style: 'font-size:20;'
          },
        }, {
          name: '机会',
          path: 'chance',
          headstyle: 2,
          icon: 'icon5',
          svg: {
            local: 't,r',
            x: '320',
            y: '360',
            d: [
              '0,0 0,0',
              '0,25 -30,25'
            ],
            state: 2,
            imgurl: 'img_fk',
            style: 'font-size:20;'
          },
          describe: '机会掘金:独家原创日历，捕捉投资机会。精选卖方研究，深挖最有价值的题材方向',
        }, {
          name: '风险',
          path: 'risk',
          describe: '全方位监测风险事件，深挖驱动逻辑，寻找避险最优解',
          svg: {
            local: 't,r',
            x: '320',
            y: '500',
            d: [
              '0,25 -25,25 -30,20 -30,-100'
            ],
            state: 2,
            imgurl: 'img_fk',
            style: 'font-size:20;'
          }
        }, {
          name: '个股',
          path: 'stocks',
          describe: '人工智能技术结合专业实力，多维度解析个股核心价值',
          headstyle: 4,
          svg: {
            local: 't,l',
            x: '320',
            y: '600',
            d: '0,0 0,0',
            state: 2,
            imgurl: 'img_fk',
            style: 'font-size:20;'
          },
        },
        {
          // 投顾菜单已隐藏
          name: '投顾',
          path: 'invest',
          headstyle: 2,
          icon: 'icon5',
          svg: {
            local: 't,r',
            x: '320',
            y: '660',
            d: [
              '0,0 0,0'
            ],
            state: 0,
            imgurl: 'img_fk',
            style: 'font-size:20;display:none;'
          },
          describe: '机会掘金:独家原创日历，捕捉投资机会。精选卖方研究，深挖最有价值的题材方向',
          hidden: true,
        }, {
          name: '特色',
          path: 'feature',
          headstyle: 2,
          icon: 'icon5',
          children: [{
            name: '理财',
            path: 'feature',
            icon: 'icon5',
            updatetime: '(交易日更新)'
          }, {
            name: '基金',
            path: 'feature',
            icon: 'icon5',
            updatetime: '(交易日更新)',
            describe: '国内首创将机会挖掘与风险提示做成深度前瞻的研究型产品。主打深度研究与独家原创，在重大政策和事件的前瞻性上下苦功，旨在为投资者捕捉投资机会，预判风险事件并作出提示。',
            children: [{
              name: '最新',
              path: 'feature',
            }, {
              name: '配置',
              path: 'feature',
            }, {
              name: '行情',
              path: 'feature',
            }, {
              name: '选基',
              path: 'feature',
            }]
          },
            {
              name: 'ETF',
              path: 'feature',
              icon: 'icon5',
              updatetime: '(交易日收盘后更新)',
              describe: '大数据结合专业实力，在海量卖方研究中深度挖掘最有价值的策略、题材和个股，并以最精炼的语言精准反馈研报的核心逻辑，尽可能呈现更多超预期的信息增量。'
            },
            {
              name: '可转债',
              path: 'feature',
              icon: 'icon5',
              updatetime: '(交易日收盘后更新)',
              describe: '大数据结合专业实力，在海量卖方研究中深度挖掘最有价值的策略、题材和个股，并以最精炼的语言精准反馈研报的核心逻辑，尽可能呈现更多超预期的信息增量。'
            },
            {
              name: '港股',
              path: 'feature',
              icon: 'icon5',
              updatetime: '(交易日收盘后更新)',
              describe: '大数据结合专业实力，在海量卖方研究中深度挖掘最有价值的策略、题材和个股，并以最精炼的语言精准反馈研报的核心逻辑，尽可能呈现更多超预期的信息增量。'
            }
          ]
        }, {
          name: '投研库',
          path: 'investmentresearchlibrary',
          headstyle: 2,
          icon: 'icon5',
        }
      ],
      menulist: [],
      nomenulist: [],
      imagelist: [{
        local: 't,l',
        x: '490',
        y: '170',
        name: '大盘如何？',
        imgurl: '/static/images/Q1.png'
      }, {
        local: 't,l',
        x: '500',
        y: '270',
        name: '有哪些机会和风险？',
        imgurl: '/static/images/Q2.png'
      }, {
        local: 't,l',
        x: '400',
        y: '540',
        name: '我的票如何？',
        imgurl: '/static/images/Q3.png'
      }, {
        local: 'b,r',
        x: '430',
        y: '250',
        name: '该怎么样操作？',
        imgurl: '/static/images/Q4.png'
      }]
    }
  },
  computed: {

  },
  beforeCreate () {
    // document.querySelector('body').setAttribute('style', '-webkit-filter: grayscale(100%);')
  },
  beforeDestroy () {
    // document.querySelector('body').removeAttribute('style')
  },
  created() {
    this.readmenu();
    this.noreadmenu();
  },
  methods: {
    // 投资日历2025年未更新，暂时隐藏
    // openCalendar(data){
    //     this.calendaRVisiAble=true
    //     this.$nextTick(()=>{
    //       this.$refs.dialog.init(data);
    //     })
    // },
    menuclick(item) {
      let that = this;
      let parentitem = null;
      that.menudata.filter(t => {
        if (t.current != null) {
          t.current = false;
        }
        if (t.children && t.children.length > 0) {
          t.children.filter(c => {
            if (c.current != null) {
              c.current = false;
            }
            if (item.name == c.name) {
              parentitem = t;
            }
            if (c.children && c.children.length > 0) {
              c.children.filter(cs => {
                if (cs.current != null) {
                  cs.current = false;
                }
                if (item.name == cs.name) {
                  parentitem = t;
                }
              })
            }
          })
        }
      })
      this.$set(item, 'current', true)
      if (parentitem != null) {
        this.$set(parentitem, 'current', true)
        parentitem.show = false;
      }
      this.handleSelect(item);
    },
    handleSelect(key) {
      let data = {};
      let that = this;
      if (typeof (key) == 'string') {
        data = this.parse(key);
      } else {
        data = key;
      }
      if (!data.path) return;

      if (data.islogin) {
        // if (that.user.state != 1) {
        //   that.index.loginbool = true;
        // } else {
          window.open(data.path, '_blank');
        // }
        return;
      }

      that.$router.push({
        // name: data.path,
        path:data.path,
        query: {
          name: data.name,
          activeName: data.activeName,
          currentTab: data.currentTab,
          activeCkName: data.activeCkName,
          currentCkTab: data.currentCkTab,
          activeRgName: data.activeRgName,
          currentRgTab: data.currentRgTab,
          activeKcName: data.activeKcName,
          currentKcTab: data.currentKcTab
        }
      })
    },
    //是否是数组
    isArray (obj) {
      if (obj) {
        if (Object.prototype.toString.call(obj) == '[object Array]') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    shallowCopy(src, exclude) {
      var dst = {};
      if (!exclude) exclude = [];
      for (var prop in src) {
        if (src.hasOwnProperty(prop) && (typeof (src[prop]) != 'object' || exclude.indexOf(prop) != -1)) {
          dst[prop] = src[prop];
        }
      }
      return dst;
    },
    fontx(item) {
      let wz = 0;
      if (item.svg.fontx) {
        wz = parseInt(item.svg.fontx);
      } else {
        let middle = 50;
        if (item.svg.style && item.svg.style.indexOf('20') != -1) {
          middle = 45;
        }
        let lent = item.petname ? item.petname.length : item.name.length;
        wz = middle - lent * 10 + 20;
        if (wz < 0) {
          wz = 0
        }
      }
      return wz
    },
    fonty(item) {
      let wz = 15;
      if (item.svg.style && item.svg.style.indexOf('20') != -1) {
        wz = 10.5;
      }
      return wz
    },
    getxy(item) {
      let x, y;
      if (item.local && item.local.indexOf('r') != -1) {
        let w = 130;
        if (item.w) {
          w = item.w;
        }
        x = this.svgwidth - parseInt(item.x) - w - (this.svgwidth - this.svgbasewidth) / 2;
      } else {
        x = (this.svgwidth - this.svgbasewidth) / 2 + parseInt(item.x);
      }
      if (item.local && item.local.indexOf('b') != -1) {
        let h = 50;
        if (item.h) {
          h = item.h;
        }
        y = this.svgheigth - parseInt(item.y) - h - (this.svgheigth - this.svgbaseheight) / 2;
      } else {
        y = (this.svgheigth - this.svgbaseheight) / 2 + parseInt(item.y);
      }
      return x + ',' + y;
    },
    over(that) {
      // this.outimg();
      let idval = that.target.getAttribute("idval");
      switch(idval) {
        case 'g1_use':
          let g1 = document.getElementById("text2");
          g1.style.display = 'block';
          let g2 = document.getElementById("text3");
          g2.style.display = 'block';
          break;
        case 'g4_use':
          let t1 = document.getElementById("text5");
          t1.style.display = 'block';
          let t2 = document.getElementById("text6");
          t2.style.display = 'block';
          let t3 = document.getElementById("text7");
          t3.style.display = 'block';
          break;
        case 'g25_use':
          let t4 = document.getElementById("text26");
          t4.style.display = 'block';
          let t5 = document.getElementById("text27");
          t5.style.display = 'block';
          break;
        case 'g28_use':
          let t7 = document.getElementById("text29");
          t7.style.display = 'block';
          let t8 = document.getElementById("text30");
          t8.style.display = 'block';
          let t9 = document.getElementById("text31");
          t9.style.display = 'block';
          break;
        case 'g32_use':
          let t10 = document.getElementById("text33");
          t10.style.display = 'block';
          let t11 = document.getElementById("text34");
          t11.style.display = 'block';
          break;
        case 'g35_use':
          let t14 = document.getElementById("text36");
          t14.style.display = 'block';
          let t15 = document.getElementById("text37");
          t15.style.display = 'block';
          break;
        case 'g31_use':
          let t17 = document.getElementById("text32");
          t17.style.display = 'block';
          let t18 = document.getElementById("text33");
          t18.style.display = 'block';
          break;
        case 'g8_use':
          let t19 = document.getElementById("text9");
          t19.style.display = 'block';
          let t20 = document.getElementById("text10");
          t20.style.display = 'block';
          let t21 = document.getElementById("text11");
          t21.style.display = 'block';
          let t22 = document.getElementById("text12");
          t22.style.display = 'block';
          break;
        case 'g24_use':
          let g23 = document.getElementById("text25");
          g23.style.display = 'block';
          let g24 = document.getElementById("text26");
          g24.style.display = 'block';
          let g25 = document.getElementById("text27");
          g25.style.display = 'block';
          break;
        case 'g21_use':
          let t24 = document.getElementById("text22");
          t24.style.display = 'block';
          let t25 = document.getElementById("text23");
          t25.style.display = 'block';
          break;
        case 'g14_use':
          let g26 = document.getElementById("text15");
          g26.style.display = 'block';
          let g27 = document.getElementById("text16");
          g27.style.display = 'block';
          let g28 = document.getElementById("text17");
          g28.style.display = 'block';
          break;
        case 'g37_use':
          let t27 = document.getElementById("text38");
          t27.style.display = 'block';
          let t28 = document.getElementById("text39");
          t28.style.display = 'block';
          break;
      }
      let target = document.getElementById(idval);
      if (target == null || target.length <= 0) {
        that.target.style.fill = "#afdaff";
        return;
      };
      let xlink = target.getAttribute("xlink:href");
      if (xlink.indexOf('_b') == -1)
        target.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', xlink + '_b');
    },
    out(that) {
      this.outimg();
      let idval = that.target.getAttribute("idval");
      // switch(idval) {
      //   case 'g2_use':
      //     let t1 = document.getElementById("text3");
      //     t1.style.display = 'none';
      //     let t2 = document.getElementById("text4");
      //     t2.style.display = 'none';
      //     let t3 = document.getElementById("text5");
      //     t3.style.display = 'none';
      //     break;
      //   case 'g6_use':
      //     let t4 = document.getElementById("text7");
      //     t4.style.display = 'none';
      //     let t5 = document.getElementById("text8");
      //     t5.style.display = 'none';
      //     let t6 = document.getElementById("text9");
      //     t6.style.display = 'none';
      //     break;
      //   case 'g10_use':
      //     let t7 = document.getElementById("text11");
      //     t7.style.display = 'none';
      //     let t8 = document.getElementById("text12");
      //     t8.style.display = 'none';
      //     let t9 = document.getElementById("text13");
      //     t9.style.display = 'none';
      //     break;
      //   case 'g15_use':
      //     let t10 = document.getElementById("text16");
      //     t10.style.display = 'none';
      //     let t11 = document.getElementById("text17");
      //     t11.style.display = 'none';
      //     let t12 = document.getElementById("text18");
      //     t12.style.display = 'none';
      //     let t13 = document.getElementById("text19");
      //     t13.style.display = 'none';
      //     break;
      //   case 'g23_use':
      //     let t14 = document.getElementById("text24");
      //     t14.style.display = 'none';
      //     let t15 = document.getElementById("text25");
      //     t15.style.display = 'none';
      //     let t16 = document.getElementById("text26");
      //     t16.style.display = 'none';
      //     break;
      //   case 'g31_use':
      //     let t17 = document.getElementById("text32");
      //     t17.style.display = 'none';
      //     let t18 = document.getElementById("text33");
      //     t18.style.display = 'none';
      //     break;
      //   case 'g34_use':
      //     let t19 = document.getElementById("text35");
      //     t19.style.display = 'none';
      //     let t20 = document.getElementById("text36");
      //     t20.style.display = 'none';
      //     let t21 = document.getElementById("text37");
      //     t21.style.display = 'none';
      //     break;
      //   case 'g38_use':
      //     let t22 = document.getElementById("text39");
      //     t22.style.display = 'none';
      //     let t23 = document.getElementById("text40");
      //     t23.style.display = 'none';
      //     break;
      //   case 'g41_use':
      //     let t24 = document.getElementById("text42");
      //     t24.style.display = 'none';
      //     let t25 = document.getElementById("text43");
      //     t25.style.display = 'none';
      //     break;
      //   case 'g45_use':
      //     let t26 = document.getElementById("text46");
      //     t26.style.display = 'none';
      //     break;
      //   case 'g47_use':
      //     let t27 = document.getElementById("text48");
      //     t27.style.display = 'none';
      //     let t28 = document.getElementById("text49");
      //     t28.style.display = 'none';
      //     break;
      //   case 'g50_use':
      //     let t29 = document.getElementById("text51");
      //     t29.style.display = 'none';
      //     break;
      // }
      let target = document.getElementById(idval);
      if (target == null || target.length <= 0) {
        that.target.style.fill = "#fff";
        return;
      };
      let xlink = target.getAttribute("xlink:href");
      if (xlink.indexOf('_b') != -1) {
        xlink = xlink.replace('_b', '');
        target.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', xlink);
      }
    },
    outimg() {
      let that = this;
      that.menulist.filter((t, idx) => {
        let iddom = document.getElementById('g' + idx + '_use');

        if (iddom != null) {
          let xlink = iddom.getAttribute("xlink:href");
          if (xlink.indexOf('_b') != -1) {
            xlink = xlink.replace('_b', '');
            iddom.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', xlink);
          }
        }
      });
    },
    readmenu: function () {
      let that = this;
      that.menulist = [];
      let list = [];
      that.menudata.filter(t => {
        if (t.hidden) return;
        list.push(that.shallowCopy(t, ["svg"]));
        if (t.children) {
          let listchild = that.menuchildren(t.children);
          list = list.concat(listchild);
        }
      })
      list.some(t => {
        if (t.svg) {
          if (this.isArray(t.svg)) {
            t.svg.filter(l => {
              let newsitem = {
                ...t
              };
              newsitem.svg = l;
              that.menulist.push(newsitem);
            })
          } else {
            that.menulist.push(t)
          }
        }
      })
    },
    noreadmenu: function () {
      let that = this;
      that.nomenulist = [];
      let list = [];
      that.nomenudata.filter(t => {
        list.push(that.shallowCopy(t, ["svg"]));
        if (t.children) {
          let listchild = that.menuchildren(t.children);
          list = list.concat(listchild);
        }
      })
      list.some(t => {
        if (t.svg) {
          if (this.isArray(t.svg)) {
            t.svg.filter(l => {
              let newsitem = {
                ...t
              };
              newsitem.svg = l;
              that.nomenulist.push(newsitem);
            })
          } else {
            that.nomenulist.push(t)
          }
        }
      })
    },
    menuchildren: function (item) {
      let that = this;
      let list = [];
      item.filter(t => {
        list.push(that.shallowCopy(t, ["svg"]));
        if (t.children) {
          let listchild = that.menuchildren(t.children);
          if (listchild != null)
            list = list.concat(listchild);
        }
      })
      return list;
    }
  },
  watch: {
    $route(to, from) {
      this.readmenu();
    },
    'user.state'() {
      this.readmenu();
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='css' scoped>
.home_bg {
  background-size: 100% 100%;
  margin: 0 auto 0;
  text-align: center;
  background-image: url(/static/images/home_bg.webp),url(/static/images/home_bg.png);
}

#g6_use{
  display: none;
}

.main {
  width: 1200px;
  min-height: 900px;
  margin: 0 auto;
  background-size: 95% 95%;
  position: relative;
}

.item {
// min-width: 100px;
  height: 50px;
  line-height: 50px;
  color: #fff;
  position: absolute;
  text-align: left;
}

.item:hover {
  background-color: rgba(161, 193, 241, 0.5);
  filter: blur(15px);
  box-shadow: 0 0 15px #fff;
}

>>>#text0{
  fill: rgb(175,218,255) !important;
}

.yearImg{
  position: fixed;
  left: 260px;
  bottom: 15%;
  z-index: 999;
}

.yearImg img{
  width: 90px;
  height: 134px;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue